import { MAX_DEFAULT_DIMENSION_PX } from 'ContentUtils/constants/ImagePerformanceTypes';
export const getMaxDimensionsBasedOnImageSize = (width, height) => {
  const hasWidthAndHeight = width && height;
  const biggestDimension = Math.max(width, height);
  const hasDimensionOverMaxDefault = biggestDimension > MAX_DEFAULT_DIMENSION_PX;
  if (hasWidthAndHeight && hasDimensionOverMaxDefault) {
    const aspectRatio = width / height;
    const adjustedWidth = biggestDimension === width ? MAX_DEFAULT_DIMENSION_PX : MAX_DEFAULT_DIMENSION_PX * aspectRatio;
    const adjustedHeight = biggestDimension === height ? MAX_DEFAULT_DIMENSION_PX : MAX_DEFAULT_DIMENSION_PX / aspectRatio;
    return {
      maxWidth: adjustedWidth,
      maxHeight: adjustedHeight,
      areaReductionRatio: adjustedWidth * adjustedHeight / (width * height)
    };
  }
  return {
    maxWidth: width,
    maxHeight: height,
    areaReductionRatio: 0
  };
};